import {
  LibrarySymbolInfo,
  PeriodParams,
} from 'modules/TradingChart/components/TradingView/sources/charting_library.min';
import {
  BarsData,
} from '../typings';

export interface IBarsProviderRest {
  getHistoricalBars(
    symbolInfo: LibrarySymbolInfo,
    resolution: string,
    periodParams: PeriodParams,
  ): Promise<BarsData>;
}

export const ONE_MINUTE_CANDLES_FETCH_LIMIT = 500;
export const ONE_DAY_CANDLES_FETCH_LIMIT = 2500;
